import { useNavigate } from 'react-router-dom';

const PageNotFound = (props) => {
    const navigate=useNavigate()
    return (
       <div className="PnfBg">
            <div className="container">
                <div className="PnfDv">
                    <img src={require('../../assets/images/logo.png')} alt="" className='d-block mx-auto PnfIg1' />
                    <img src={require('../../assets/images/404.png')} alt="" className='d-block mx-auto PnfIg2' />
                    <p>Page Not Found</p>
                    <button className='btn CmnBtn d-block mx-auto h-46 px-4' onClick={()=>navigate('/')}>Back to home</button>
                </div>
            </div>
            <div className="BnrSecBrdBtm"></div>
            <div className="BnrSecBrdRgt"></div>
            <div className="BnrSecBrdRgtSml"></div>
       </div>
    );   
}

export default PageNotFound;